<template>
  <aha-modal
    :title="$i18nPresenter.t('Delete confirmation')"
    action-position="justify-end"
    @hide="$emit('hide')"
  >
    <p>{{ $i18nPresenter.t('Are you sure you want to delete this question image?') }}</p>
    <template #action>
      <aha-button
        variant="danger"
        @click="handleDeleteQuestionImage()"
        has-margin-right
      >
        {{ $i18nPresenter.t('OK') }}
      </aha-button>
      <aha-link @click="handleModalCancel()">
        <span class="font-bold">{{ $i18nPresenter.t('Cancel') }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import SlideApi from '@/api/slide'
import Socket from '@/socket'
import eventCategories from '@/constant/eventCategories'
import utils from '@/util'
import { removeObjectFromIndexedDB } from '@/utils/indexedDB/indexed.db'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
  },
  methods: {
    ...mapActions(['setSyncLoadingAction', 'updateSlideActiveAction']),
    async handleDeleteQuestionImage() {
      const payload = {
        presentationId: this.presentation.id,
        accessCode: this.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
        image: null,
        showQuestionImage: false,
        presenting: this.isPresentingOrBackstage,
      }
      this.updateSlideActiveAction(payload)
      removeObjectFromIndexedDB(this.slideActive.id, 'question_images')
      await SlideApi.updateSlideById(this.slideActive.id, payload)
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Delete question image > OK',
      )
      this.$emit('hide')
    },

    handleModalCancel() {
      this.$emit('hide')
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Delete question image > Cancel',
      )
    },
  },
}
</script>
